import { throttle } from 'lodash';
import { useEffect, useState } from 'react';
export const useScrollOffset = ({ element, offset, axis = 'y', throttleDelayMs = 200, isThrottleLeading: leading = true, }) => {
    const [isReached, setReached] = useState(false);
    const handler = () => {
        if (element.current) {
            const { [axis]: scrollOffset = 0 } = element.current.getBoundingClientRect();
            setReached(scrollOffset <= offset);
        }
    };
    // FIXME: Replace manual event registration with `useEvent` from react-use
    useEffect(() => {
        window.addEventListener('scroll', throttle(handler, throttleDelayMs, { leading }));
        return () => {
            window.removeEventListener('scroll', () => throttle(handler, throttleDelayMs, { leading }));
        };
    }, []);
    return [isReached];
};
